export default (paymentValidUntil: string | null | undefined): boolean => {
  // If there's no validUntil date, payment is always due
  if (paymentValidUntil === null || paymentValidUntil === undefined) {
    return true
  }

  // Parse the validUntil date
  const validUntilDate = new Date(paymentValidUntil)
  if (validUntilDate.toString() === "Invalid Date") {
    return true
  }

  // Ensure validUntil is at UTC midnight for accurate date comparison
  const validUntilUTC = new Date(Date.UTC(
    validUntilDate.getUTCFullYear(),
    validUntilDate.getUTCMonth(),
    validUntilDate.getUTCDate()
  ))

  // Get current date in UTC
  const currentDate = new Date()
  const currentDateUTC = new Date(Date.UTC(
    currentDate.getUTCFullYear(),
    currentDate.getUTCMonth(),
    currentDate.getUTCDate()
  ))

  // Return true if current date is at or after the "validUntil" date
  return currentDateUTC >= validUntilUTC
}
